import { render, staticRenderFns } from "./AvukatTalepMalTuruRadio.vue?vue&type=template&id=0a4f6912"
import script from "./AvukatTalepMalTuruRadio.vue?vue&type=script&lang=ts"
export * from "./AvukatTalepMalTuruRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports